import type { HeadlinePriceType } from '@phx/data-sources/medication-marketplace';

import type {
    ProductDisclaimer,
    ProductDisclaimerSlot,
} from '../configuration/shared';
import { useMedicationConfigOverride } from '../contexts/DrugProgramProvider';
import type {
    AuthorizedMedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../graphql/generated/graphql';
import { getMedicationNdc } from '../util/get-medication-ndc';

export type UseMedicationDisclaimersProps = {
    headlinePriceType?: HeadlinePriceType | null;
    medication:
        | AuthorizedMedicationInfoFragment
        | UnknownMedicationInfoFragment;
    slot: ProductDisclaimerSlot;
};

export const useMedicationDisclaimers = ({
    headlinePriceType,
    medication,
    slot,
}: UseMedicationDisclaimersProps): ProductDisclaimer[] => {
    const { ndcDisclosureConfigs } = useMedicationConfigOverride();
    const ndc = getMedicationNdc(medication);

    if (!headlinePriceType || !ndc || !ndcDisclosureConfigs) {
        return [];
    }

    const disclosures = ndcDisclosureConfigs[ndc];

    if (!disclosures || !disclosures.disclaimers) {
        return [];
    }

    return disclosures.disclaimers.filter(
        (disclaimer) =>
            disclaimer.headlinePriceTypes.includes(headlinePriceType) &&
            disclaimer.slots.includes(slot)
    );
};
